module.exports = __webpack_public_path__ + "img/gh.8adef5e9.svg";